module.exports = __webpack_public_path__ + "icon.f17a3899.svg";